/* eslint-env mocha
 * Search Filter components
 */
export default {
  data () {
    return {
      filterItems: [
        {
          label: 'Date', // menu label to display
          elements: [
            'Today',
            'Last 7 days',
            'Month to date',
            'Previous month',
            'All time',
            'Custom'
          ],
          type: 'radio',
          name: 'date',
          dataTrack: 'select date'
        },
        {
          label: 'Ratings',
          elements: [5, 4, 3, 2, 1],
          type: 'checkbox',
          name: 'ratings',
          dataTrack: 'select ratings'
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/search-filter-menus.js